import * as React from 'react';
import { Link } from 'react-router';

import Agenda from './widgets/Agenda';
import Carousel from './widgets/Carousel';
import Reviews from './widgets/Reviews';
import Layout from './Layout';

export default class Home extends React.Component<{}, {}> {

    render() {
        return (
            <Layout id="home"
                    title="Welcome to iBeachResort"
                    
                    background="/images/cloud.jpg">

              <Agenda />

              {/* synopsis */}
              <div className="row">
                <div className="twelve wide center aligned column"
                     style={ { fontSize: '16px', lineHeight: '18px', color: '#666' } }>
                  We offer three different styles of rooms
                  to best accommodate you during your stay.
                  <br />
                  (Sorry, no handicap rooms & accommodations are available.Pets not allowed, service animals are welcome, and are exempt from fees)
                </div>
              </div>

              <div className="row">
                <div className="four wide column">
                  <h2>
                    Welcome<br />
                    to iBeachResort
                  </h2>
                  <p>
                    Our Resort is located directly on the beach
                    of the beautiful Gulf of Mexico.
                    There's always plenty to do
                    whether you choose to relax around our heated pool,
                    stroll along the beach, walk to a local shop,
                    or enjoy a fine dining experience.
                  </p>
                  <Link to="/rooms" className="explore">Explore all our rooms</Link>
                </div>

                <Link to="/efficiency-room" className="four wide card widget column">
                  <img src="/images/efficiency_room.jpg" alt="efficiency room" />
                  <h3>
                    Efficiency Room
                    <small>Includes fully equipped kitchen.</small>
                  </h3>
                </Link>

                <Link to="/bedroom-suite" className="four wide card widget column">
                  <img src="/images/bedroom_suite.jpg" alt="bedroom suite" />
                  <h3>
                    Bedroom Suite
                    <small>Two to six people occupancy.</small>
                  </h3>
                </Link>
              </div>

              {/* amenities */}
              <div className="row">
                <div className="eight wide centered column">
                  <img src="/images/swimming_pool.jpg" alt="swimming pool" className="swimming_pool" />
                </div>
              </div>

              <div className="row">
                <div className="seven wide column">
                  <img src="/images/ice_drink.jpg" alt="ice drink" className="ice_drink" />
                </div>

                <div className="five wide desc widget column">
                  <h2>
                    We offer<br />
                    many amenities
                  </h2>
                  <p>
                    One of our favorites is
                    the crystal outdoor heated swimming pool.
                  </p>
                  <ul>
                    <li>Ice Machine</li>
                    <li>On-Site Guest Laundry</li>
                    <li>Shuffle Board</li>
                    <li>Small library with several options of literature</li>
                    <li>Barbeque Grill Available for Guests Use</li>
                    <li>Complimentary Wireless Internet</li>
                    <li>Daily Complimentary Coffee</li>
                    <li>Daily Housekeeping Service (except holidays)</li>
                    <li>Beach Sand Toys</li>
                    <li>Patio Furniture perfect for relaxing or enjoying a picnic meal</li>
                  </ul>
                </div>

                <div className="three wide column" style={ { marginTop: '7px' } }>
                  <img src="/images/shuffleboard.jpg" alt="shuffleboard" />
                </div>
              </div>

              {/* locality */}
              <div className="row">
                <div className="five wide column">
                  <h2>"The Treasure of the Gulf Coast."</h2>
                  <p>
                    Treasure Island is located on Florida's beautiful
                    Gulf Coast and is blessed with miles of
                    gorgeous white sand beaches that boast that
                    "Old Florida" feel yet Treasure Island is
                    part of the Tampa Bay region, one of
                    the nation's fastest growing metro areas.
                  </p>
                  <p>
                    Miles of clean, wide white sand beaches make
                    Treasure Island the perfect Florida family destination.
                    The warm gentle waters of the Gulf of Mexico and
                    the very best sunsets in the world await you
                    when you visit Treasure Island.
                  </p>
                  <Link to="/rooms" className="explore">Explore all our rooms</Link>
                </div>
                <div className="seven wide column">
                  <img src="/images/white_sand_beach.jpg" alt="white sand beach" className="white_sand_beach" />
                </div>
              </div>
              <div className="row">
                <div className="ten wide centered column">
                  <Carousel>
                    <img src="/images/kite_event.jpg" />
                    <img src="/images/plain_beach.jpg" />
                    <img src="/images/ports.jpg" />
                    <img src="/images/cloud_beach.jpg" />
                    <img src="/images/swimming_beach.jpg" />
                  </Carousel>
                </div>
              </div>

              {/* routes */}
              <div className="row">
                <div className="eight wide column" id="google-map">
                  <iframe src="https://maps.google.com/maps?f=q&source=s_q&hl=en&geocode=&q=10450+Gulf+Boulevard,+Treasure+Island,+FL+33706&aq=0&oq=10450+Gulf+Boulevard+Treasure+Island,+FL+33706&sll=27.698638,-83.804601&sspn=15.335231,19.753418&ie=UTF8&hq=&hnear=10450+Gulf+Blvd,+Treasure+Island,+Pinellas,+Florida+33706&t=m&ll=27.766874,-82.768679&spn=0.036455,0.054932&z=14&iwloc=A&output=embed" className="google maps" style={ { width: '100%', height: '340px', border: '0' } }>
                  </iframe>
                </div>
                <div className="four wide column">
                  <h2>How to reach iBeachResort</h2>
                  <p>
                    From I-275, take exit 23b. Turn West on Central Ave. and
                    continue until it ends on Gulf Blvd in Treasure Island
                    (after you cross Park Street, you will cross a bridge
                    where Central Ave. becomes 107th Ave).
                    Turn left on Gulf Blvd.
                    We are located 2.5 blocks South on the right.
                  </p>
                  <a href="https://maps.google.com/maps?f=q&source=embed&hl=en&geocode=&q=10450+Gulf+Boulevard,+Treasure+Island,+FL+33706&aq=0&oq=10450+Gulf+Boulevard+Treasure+Island,+FL+33706&sll=27.698638,-83.804601&sspn=15.335231,19.753418&ie=UTF8&hq=&hnear=10450+Gulf+Blvd,+Treasure+Island,+Pinellas,+Florida+33706&t=m&ll=27.766874,-82.768679&spn=0.036455,0.054932&z=14&iwloc=A"
                     target="_blank" className="explore">Check location</a>
                </div>
              </div>

              {/* reviews */}
              <Reviews />
            </Layout>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/Home.tsx
 **/